import React from "react";
import { Box, Container, Typography, Divider } from "@mui/material";

type HeroProps = {
  image: string;
  title: string;
  blurb: string;
  stretch?: boolean;
};

const Hero: React.FC<HeroProps> = ({ image, title, blurb, stretch = true }) => {
  const accentColor = "#1B2E85";

  return (
    <>
      {/* HERO IMAGE + STRIP */}
      <Box
        sx={{
          position: "relative",
          overflowX: "clip",
          overflowY: "visible",
          boxSizing: "border-box",
          pt: "80px",
        }}
      >
        {/* If stretch = true → cover (crop), else contain (fit) */}
        <Box
          component="img"
          src={image}
          alt={`${title} hero`}
          sx={{
            display: "block",
            width: "100%",
            height: "auto",
            maxHeight: { xs: 200, sm: 260, md: 320, lg: 380 },
            objectFit: stretch ? "cover" : "contain",
            objectPosition: "center",
            mx: "auto",
          }}
        />

        <Box
          sx={{
            width: "100%",
            height: { xs: 6, sm: 11, md: 15 },
            backgroundColor: accentColor,
          }}
        />

        {/* CARD STRADDLING HERO EDGE */}
        <Container
          maxWidth="sm"
          disableGutters
          sx={{
            position: "absolute",
            left: "50%",
            bottom: 0,
            transform: "translate(-50%, 60%)",
            zIndex: 10,
            width: "100%",
            px: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: "#F5F5F5",
              width: "100%",
              maxWidth: 600,
              mx: "auto",
              p: { xs: 2, sm: 3, md: 4 },
              textAlign: "center",
              borderRadius: 1.5,
              boxShadow: 2,
            }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              color={accentColor}
              sx={{
                mb: 2,
                fontSize: "clamp(1.4rem, 4vw, 2.5rem)",
              }}
            >
              {title}
            </Typography>

            <Divider
              sx={{
                width: { xs: 40, sm: 50, md: 60 },
                height: { xs: 3, md: 4 },
                backgroundColor: accentColor,
                mx: "auto",
                mb: 2,
                border: 0,
              }}
            />

            <Typography
              variant="h6"
              color="text.secondary"
              sx={{
                fontSize: "clamp(0.85rem, 2.5vw, 1.1rem)",
              }}
            >
              {blurb}
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* SPACER BELOW CARD */}
      <Box sx={{ height: { xs: 120, sm: 140, md: 160 } }} />
    </>
  );
};

export default Hero;
